/**
 * Editable array control - click to edit inline
 */

import { useState } from 'react';
import { TYPE_COLORS } from '../utils';

interface ArrayControlProps {
  value: any[];
  onChange: (value: any[]) => void;
}

export function ArrayControl({ value, onChange }: ArrayControlProps) {
  const [editing, setEditing] = useState(false);
  const [editValue, setEditValue] = useState('');

  const startEdit = () => {
    const arr = Array.isArray(value) ? value : [];
    setEditValue(arr.join(', '));
    setEditing(true);
  };

  const saveEdit = () => {
    const parsed = editValue
      .split(',')
      .map(s => s.trim())
      .filter(s => s !== '')
      .map(s => {
        const num = Number(s);
        return isNaN(num) ? s : num;
      });
    onChange(parsed);
    setEditing(false);
  };

  const cancelEdit = () => {
    setEditing(false);
  };

  if (editing) {
    return (
      <div style={{
        marginLeft: 'auto',
        display: 'flex',
        alignItems: 'center',
        gap: 4
      }}>
        <input
          type="text"
          value={editValue}
          onChange={(e) => setEditValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') saveEdit();
            if (e.key === 'Escape') cancelEdit();
          }}
          onBlur={saveEdit}
          autoFocus
          style={{
            width: 100,
            background: '#374151',
            color: '#e5e7eb',
            border: '1px solid #6b7280',
            borderRadius: 3,
            padding: '2px 4px',
            fontSize: 10,
            fontFamily: 'monospace'
          }}
          className="nodrag"
        />
      </div>
    );
  }

  return (
    <span
      onClick={startEdit}
      style={{
        color: TYPE_COLORS.pattern,
        fontFamily: 'monospace',
        fontSize: 11,
        marginLeft: 'auto',
        maxWidth: 120,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        padding: '2px 4px',
        borderRadius: 3,
        background: 'rgba(139, 92, 246, 0.1)'
      }}
      title="Click to edit"
    >
      {Array.isArray(value) ? `[${value.join(', ')}]` : '[]'}
    </span>
  );
}
